const CopyRight = () => {
    return (
        <div className="w-full bg-[#5AE65E]">
            <div className="w-full max-w-[1300px] m-auto mx-auto flex flex-col items-center text-center px-6 py-4 text-[#1a2b13] text-sm font-medium md:flex-row md:items-center md:justify-between md:text-left">
                <div>@2025 All the Copyright Reserved.</div>
                <div className="mt-1 md:mt-0">
                    <a href="#" className="hover:underline">Privacy Policy</a> |
                    <a href="#" className="hover:underline ml-1">Terms &amp; Condition</a>
                </div>
            </div>
        </div>
    )
}

export default CopyRight;